






































































































































import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import { apiWorkOrderTypeLists, apiWorkOrderTypeStatus } from '@/api/work_order'

@Component
export default class WorkOrderTypeList extends Vue {
    queryObj: any = {
      keyword: '',
      service_category: '',
      status: ''
    }

    tableData: any[] = []
    loading = false

    pager = new RequestPaging()
    getList (page?: number): void {
      page && (this.pager.page = page)
      this.loading = true
      this.pager
        .request({
          callback: apiWorkOrderTypeLists,
          params: {
            ...this.queryObj
          }
        })
        .then((res: any) => {
          this.tableData = res.lists || []
        })
        .finally(() => {
          this.loading = false
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        service_category: '',
        status: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/work_order/type/add')
    }

    handleEdit (row: any) {
      this.$router.push({ path: '/work_order/type/edit', query: { id: row.id } })
    }

    handleToggleStatus (row: any) {
      const action = row.status ? '停用' : '启用'
      this.$confirm(`确定要${action}该服务类型吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        apiWorkOrderTypeStatus({
          id: row.id,
          status: row.status ? 0 : 1
        }).then(() => {
          this.$message.success(`${action}成功`)
          this.getList()
        })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.getList()
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.getList()
    }

    // 处理图片加载错误
    handleImageError (event: Event, row: any) {
      const imgElement = event.target as HTMLImageElement
      imgElement.style.display = 'none'
      row._iconError = true
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    getServiceCategoryText (category: number): string {
      const categoryMap = ['', '维修/安装', '搬家保洁/回收']
      return categoryMap[category] || '未知'
    }

    created () {
      this.getList()
    }

    activated () {
      this.getList()
    }
}
